
import { mainStore, userToolStore } from '@/store';
import _, { over } from 'lodash';
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class List extends Vue {
  isLoading = false;
  link = '';

  playbooks = [
    {
      title: 'Playbook Digital Nacional KNN',
      subtitle: '',
      link_drive: 1,
    },
    {
      title: 'Playbook Expansão KNN',
      subtitle: '',
      link_drive: 2,
    },
  ];

  get currentUserTool() {
    return (
      _.find(userToolStore.currentUserTools, { tool_id: 108 }) || {
        allow_view: false,
        allow_edit: false,
        allow_delete: false,
        allow_create: false,
      }
    );
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  async beforeMount() {
    if (!this.currentUserTool.allow_view) {
      this.$router.push({ name: 'main-dashboard' });
    }
  }
}
